/**
 * Read prices for a list of cards in waves, a screenful first.
 *
 * The collection arrives in three goes - what was cached locally, the first
 * page, then the tail - and each one restarts this. So a card is remembered
 * once it has been read, and a later pass skips it rather than reading the
 * whole collection again.
 *
 * The ordering below is the entire point of the module, and it is not obvious.
 * A card is claimed only after its prices have been applied, never when the
 * wave is planned. Claiming up front reads as equivalent and is not: the next
 * batch of cards cancels this run part-way through, and every card it had
 * already claimed is then skipped by the run that replaces it - claimed by a
 * pass that never applied a single price. On a warm open the cached wave claims
 * the entire collection, and nothing prices at all.
 */
export async function runPriceWaves({
  cards, claimed, headSize, read, apply, isCancelled = () => false,
}) {
  const pending = cards.filter(c => !claimed.has(c.id));
  if (pending.length === 0) return [];

  // Top down, so the rows in front of the user carry prices while the rest of
  // the collection is still being read.
  const waves = [pending.slice(0, headSize), pending.slice(headSize)]
    .filter(w => w.length > 0);

  const done = [];
  for (const wave of waves) {
    const found = await read(wave);
    if (isCancelled()) return done;

    for (const card of wave) claimed.add(card.id);
    done.push(...wave);
    apply(wave, found);
  }
  return done;
}
